import { useSelector } from '@xstate/react';
import { UserContext } from '../../app';
import { ChatbotButton } from '../../components';
import { ChatbotContext } from './index';

export const ChatbotButtonWrapper = () => {
  const userRef = UserContext.useActorRef();
  const { registered } = useSelector(userRef, (state) => state.context);

  // Only show chatbot after account setup is complete
  if (!registered) {
    return null;
  }

  return (
    <ChatbotContext.Provider>
      <ChatbotButton />
    </ChatbotContext.Provider>
  );
};
